import { Component, OnInit } from '@angular/core';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ManageOpenShiftsService } from '../../services/manage-open-shifts.service';

@Component({
  selector: 'app-manage-open-shifts-list',
  templateUrl: './manage-open-shifts-list.component.html',
  styleUrls: ['./manage-open-shifts-list.component.scss']
})
export class ManageOpenShiftsListComponent implements OnInit {
  subject: Subject<any>;
  openShiftStatusColors = AppSettings.OPEN_SHIFT_STATUS;
  date = new Date();
  hideFilterSection = false;
  searchedTeam = '';
  userList = [];
  statusList = [];
  shiftDetails = [];
  openShiftStatusList = [];
  selectedUserType = '';
  selectedStatus = '';
  hasShowOpenShiftPopUp = false;
  childView: any;
  hasShowPublishShiftPopUp = false;
  openShiftId = '';
  openShiftPop = false;
  openShiftStatus: any;
  maxDate = new Date();
  loginUserId: any;
  userInfo: any;
  filterLocalData: any;
  filterSavedFlag: Boolean = false;
  FilterDataFlag: any;
  isDateChanged = false;
  currentDate = new Date();
  providerList = [];
  provider = '';
  serviceRegionList: any[] = [];
  selectedServiceRegionIds: any[] = [];
  disableProvider = false;
  organizationLevelDispatch = false;
  globalConfigOS = false;
  constructor(private manageOpenShiftsService: ManageOpenShiftsService,
    private storageService: StorageService,
    private uiService: UiService,
    private commonService: CommonBindingDataService, ) {
    this.subject = new Subject();
  }

  ngOnInit(): void {
    const futureMaxDateLimit = this.commonService.getTenantConfigValue(AppSettings.EDIT_TEAM_LIST_MAX_DATE);
    this.organizationLevelDispatch = this.commonService.getGlobalConfigByKey(AppSettings.DISPATCH_LEVEL_DUTY_ON_OFF)?.value;
    this.globalConfigOS = this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.OPEN_SHIFT)?.value;
    this.maxDate.setDate(this.maxDate.getDate() + parseInt(futureMaxDateLimit, 10));
    this.userInfo = this.storageService.getItem(AppSettings.USER_DETAILS);
    if (this.userInfo) {
      this.loginUserId = this.userInfo.id;
    }
    this.applyProviderRoleScope();
    this.manageOpenShiftsService.getValue().subscribe(() => {
      this.changeFilter();
    });
    this.subject.pipe(debounceTime(500)).subscribe(() => {
      this.changeFilter();
    });
    this.manageOpenShiftsService.getDialogStatus().subscribe(value => {
      this.hasShowOpenShiftPopUp = value;
    });
    this.loadServiceRegions();
    const tagsData = this.storageService.getItem(AppSettings.TAG_DATA);
    if (tagsData == null) {
      const localTagData = localStorage.getItem('localTagdata');
      this.setDropdownValues(JSON.parse(localTagData));
    } else {
      this.setDropdownValues(tagsData);
      localStorage.removeItem('localTagdata');
    }
  }

  setDropdownValues(tagsData) {
    tagsData.open_shift_status.forEach(element => {
      this.openShiftStatusList.push({ label: element.tagValue, value: element.tagId });
    });
    this.statusList.push({ label: this.commonService.getLabel('All'), value: '' });
    this.statusList = [...this.statusList, ...this.openShiftStatusList];
    if (this.disableProvider) {
      // this.userList.push({ label: this.commonService.getLabel('All'), value: '' });
      tagsData.open_shift_user_type.forEach(element => {
        if (element.tagValue === 'Mobile App') {
          this.userList.push({ label: element.tagValue, value: element.tagId });
        }
        this.selectedUserType = '10';
      });
    } else {
      this.userList.push({ label: this.commonService.getLabel('All'), value: '' });
      tagsData.open_shift_user_type.forEach(element => {
        this.userList.push({ label: element.tagValue, value: element.tagId });
      });
    }
    if (!this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.MANAGE_SHIFT)?.value) {
      this.userList.pop();
    }
    this.getProvider();
  }

  getProvider() {
    // this.providerList.push({ label: this.commonBindingDataService.getLabel('All'), value: '' });
    this.manageOpenShiftsService.getProvider().subscribe(results => {
      const providerData = results;
      this.providerList.push({ label: this.commonService.getLabel('All'), value: '' });
      for (let i = 0; i < providerData.length; i++) {
        if (providerData[i].providerName !== null) {
          this.providerList.push({ label: providerData[i].providerName, value: providerData[i].id });
        }
      }
      this.getFilter();
      const filterObj: any = this.storageService.getItem(AppSettings.FILTER_DETAILS_MANAGE_SHIFT);
      this.filterLocalData = filterObj;
      const savedFilterLocal = localStorage.getItem('manageShiftFilterPresent');
      const localData = JSON.parse(savedFilterLocal);
      if (localData) {
        this.filterLocalData = localData.filterData;
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  searchTeam() {
    this.subject.next();
  }

  hideFilter(event) {
    this.hideFilterSection = event === true ? true : false;
  }

  changeFilter() {
    let filter = '';
    this.isDateChanged = true;
    if (this.selectedUserType !== undefined && this.selectedUserType !== null && this.selectedUserType !== '') {
      filter = `${filter}&userType=${this.selectedUserType}`;
    }
    if (this.selectedStatus !== undefined && this.selectedStatus !== null && this.selectedStatus !== '') {
      filter = `${filter}&shiftStatus=${this.selectedStatus}`;
    }
    if (this.searchedTeam !== undefined && this.searchedTeam !== null && this.searchedTeam !== '') {
      filter = `${filter}&searchText=${this.searchedTeam}`;
    }
    if (this.provider !== undefined && this.provider !== null && this.provider !== '') {
      filter = `${filter}&providerId=${this.provider}`;
    }
    if (this.selectedServiceRegionIds && this.selectedServiceRegionIds.length) {
      this.selectedServiceRegionIds.forEach((regionId) => {
        filter = `${filter}&serviceRegionIds=${regionId}`;
      });
    }
    this.getOpenShiftDetails(this.date, filter);
  }

  loadServiceRegions(savedRegionIds?: any[], refresh = false) {
    const regions$ = this.provider
      ? this.commonService.getServiceRegionsByProviderID(this.provider)
      : this.commonService.getServiceRegions();

    regions$.subscribe((regions) => {
      this.serviceRegionList = this.commonService.mapServiceRegionOptions(regions);
      if (savedRegionIds && savedRegionIds.length) {
        this.selectedServiceRegionIds = savedRegionIds.filter((id) =>
          this.serviceRegionList.some((region) => region.value === id)
        );
      } else if (this.selectedServiceRegionIds.length) {
        this.selectedServiceRegionIds = this.selectedServiceRegionIds.filter((id) =>
          this.serviceRegionList.some((region) => region.value === id)
        );
      }
      if (refresh) {
        this.changeFilter();
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  onProviderChange() {
    this.loadServiceRegions(undefined, true);
  }

  openShift() {
    this.hasShowPublishShiftPopUp = true;
    // this.childView.reloadUserView();
  }

  onClickOfPopupButton(event) {
    if (event !== null) {
      this.uiService.showMessage(event.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
    }
    this.hasShowPublishShiftPopUp = false;
  }

  openTeamPopup(event) {
    this.openShiftStatus = event.status;
    this.openShiftId = event.id;
    this.openShiftPop = true;
    this.manageOpenShiftsService.setDialogStatus(true);
    this.hasShowOpenShiftPopUp = true;
  }

  getOpenShiftDetails(date: any, filter?: any) {
    let filterData = moment(date).format('YYYY/MM/DD');
    if (filter) {
      filterData = `${filterData}${filter}`;
    }
    this.manageOpenShiftsService.getOpenShiftDetails(filterData).subscribe((shiftDetails) => {
      this.shiftDetails = shiftDetails.data;
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);

    });
  }

  onResetFilter() {
    if (this.filterSavedFlag) {
      this.manageOpenShiftsService.resetFilter(this.loginUserId, 'OPEN_SHIFT_FILTER').subscribe(results => {
        this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
        this.filterSavedFlag = false;
        localStorage.removeItem('manageShiftFilterPresent');
        this.storageService.removeItem(AppSettings.FILTER_DETAILS_MANAGE_SHIFT);
      }, (error) => {
        this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
      });
    }
    this.date = new Date();
    this.selectedUserType = '';
    this.selectedStatus = '';
    if (!this.disableProvider) {
      this.provider = '';
    } else {
      this.provider = this.loginUserId;
    }
    this.selectedServiceRegionIds = [];
    this.searchedTeam = '';
    this.isDateChanged = false;
    this.loadServiceRegions(undefined, true);
  }

  saveFilter() {
    const filterObj = {
      'date': new Date(this?.date)?.getTime(),
      'selectedUserType': this.selectedUserType,
      'selectedStatus': this.selectedStatus,
      'providerId': this.provider,
      'serviceRegionIds': this.selectedServiceRegionIds
    };
    const filterModel: any = {
      'userId': this.loginUserId,
      'filterType': 'OPEN_SHIFT_FILTER',
      'filterData': filterObj
    };

    this.manageOpenShiftsService.teamMemberSaveFilter(filterModel).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
      this.filterSavedFlag = true;
      localStorage.setItem('manageShiftFilterPresent', JSON.stringify(filterModel));
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  getFilter() {
    const type = 'OPEN_SHIFT_FILTER';
    this.manageOpenShiftsService.manageShiftGetFilter(this.loginUserId, type).subscribe(results => {
      this.FilterDataFlag = results.filterData;
      if (results.filterData !== null && results.filterData !== undefined) {
        const filterDataResults = JSON.parse(results.filterData);
        this.filterSavedFlag = true;
        if (filterDataResults?.selectedUserType) {
          this.selectedUserType = filterDataResults?.selectedUserType;
        }
        if (filterDataResults?.date !== 0 && filterDataResults?.date !== null) {
          this.date = new Date(filterDataResults?.date);
        }
        if (filterDataResults?.providerId && !this.disableProvider) {
          this.provider = filterDataResults?.providerId;
        }
        if (filterDataResults?.selectedStatus) {
          this.selectedStatus = filterDataResults?.selectedStatus;
        }
        if (filterDataResults?.serviceRegionIds) {
          this.selectedServiceRegionIds = filterDataResults.serviceRegionIds;
        }
        this.ensureProviderIdForRole();
        this.loadServiceRegions(filterDataResults?.serviceRegionIds, true);
        this.getFilterLocal(filterDataResults);
        this.changeFilter();
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  getFilterLocal(results) {
    if (results !== null && results !== undefined) {
      const filterDataResults = results;
      this.filterSavedFlag = true;
      if (filterDataResults?.selectedUserType) {
        this.selectedUserType = filterDataResults?.selectedUserType;
      }
      if (filterDataResults?.date !== 0 && filterDataResults?.date !== null) {
        this.date = new Date(filterDataResults?.date);
      }
      if (filterDataResults?.providerId && !this.disableProvider) {
        this.provider = filterDataResults?.providerId;
      }
      this.ensureProviderIdForRole();
      if (filterDataResults?.selectedStatus) {
        this.selectedStatus = filterDataResults?.selectedStatus;
      }
      if (filterDataResults?.serviceRegionIds) {
        this.selectedServiceRegionIds = filterDataResults.serviceRegionIds;
      }
      if (filterDataResults.date > this.currentDate || this.currentDate > filterDataResults.date) {
        this.isDateChanged = true;
      } else {
        this.isDateChanged = false;
      }
    }
  }

  private applyProviderRoleScope() {
    const roleId = this.storageService.getItem<number>(AppSettings.USER_ROLE_ID);
    if (roleId === AppSettings.PROVIDER_ROLE_ID || roleId === 11) {
      this.disableProvider = true;
      this.provider = this.loginUserId;
    }
  }

  private ensureProviderIdForRole() {
    if (this.disableProvider && this.loginUserId) {
      this.provider = this.loginUserId;
    }
  }
}
